import KundeService from '../../services/KundeService'

const state = {
  items: [],
  pageCount: 1,
  totalCount: 0,
  queryParams: {
    page: 1,
    limit: 50,
    sort: 'Lopenr',
    direction: 'asc'
  },
  loading: false,
  updating: false,
  needreload: true
}

const getters = {
  items: state => state.items,
  pageCount: state => state.pageCount,
  totalCount: state => state.totalCount,
  queryParams: state => state.queryParams,
  loading: state => !!state.loading,
  updating: state => !!state.updating,
  needreload: state => !!state.needreload || state.items.length < 1
}

const actions = {
  load: ({commit, dispatch}, kontrakt) => {
    return new Promise((resolve, reject) => {
      if (!kontrakt) {
        commit('failure')
        return resolve()
      }

      commit('load')
      KundeService.getKundeKontraktObjektList(kontrakt.Kundenr, kontrakt.Kontraktnr, state.queryParams)
        .then((response) => {
          let payload = {
            items: response.data,
            pageCount: response.headers['x-paging-pagecount'] ? parseInt(response.headers['x-paging-pagecount']) : 1,
            totalCount: response.headers['x-paging-count'] ? parseInt(response.headers['x-paging-count']) : 0
          }

          commit('success', payload)
          resolve(response)
        })
        .catch((error) => {
          commit('failure')
          reject(error)
        })
    })
  },
  reload: ({commit, dispatch}, params) => {
    commit('reload', params.queryParams || null)
    dispatch('load', params.kontrakt)
  },
  setNeedReload: ({commit, dispatch}) => {
    commit('setNeedReload')
  }
}

const mutations = {
  load: (state) => {
    state.totalCount = 0

    if (!state.updating) {
      state.loading = true
    }
  },
  reload: (state, payload) => {
    state.updating = true

    if (payload !== null) {
      state.queryParams = payload
    }
  },
  success: (state, payload) => {
    state.loading = false
    state.updating = false

    state.items = payload.items || []
    state.pageCount = payload.pageCount
    state.totalCount = payload.totalCount

    state.needreload = false
  },
  failure: (state) => {
    state.loading = false
    state.updating = false

    state.items = []
    state.pageCount = 1
    state.totalCount = 0

    state.needreload = true
  },
  setNeedReload: (state) => {
    state.needreload = true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/kundekontraktobjekt.js